import { FormProvider, useForm } from 'react-hook-form';
import { Header, IconChevronLeft, LogoBadgetCP, Conditional, Spinner, COLOR_BRAND_BLUE_40, ProgressBar } from '@consumidor-positivo/aurora';
import { Loader } from '../components/Loader';

import { useMMForm } from './hook';
import './styles.scss';

export type MMFormProps = {
  user?: any;
  token?: string;
  negativeDebts?: any[];
  onFinish?: () => void;
};

export const MMForm = (props: MMFormProps) => {
  const methods = useForm();
  const { loading, stepNumber, currentStep, totalSteps, resultLoading, prevStep, onSubmit } = useMMForm(props);

  if (loading) return <Loader isLoading onComplete={() => console.log('Loading complete')} />;

  return (
    <div className="mm-form mm-form__container">
      <div className="mm-form mm-form__content-container">
        <Header.Root>
          <Header.Button onClick={prevStep}>
            <IconChevronLeft />
          </Header.Button>
          <LogoBadgetCP />
        </Header.Root>
        <div className="mm-form mm-form__content">
          <ProgressBar currentStep={stepNumber} totalSteps={totalSteps} stepName={currentStep?.label} />
          <Conditional
            condition={resultLoading}
            renderIf={
              <div className="mm-form__loader">
                <Spinner color={COLOR_BRAND_BLUE_40} size={42} />
              </div>
            }
            renderElse={
              <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)}>
                  <Conditional condition={Boolean(currentStep)} renderIf={currentStep?.component} />
                </form>
              </FormProvider>
            }
          />
        </div>
      </div>
      <div className="mm-form mm-form__image"></div>
    </div>
  );
};
